import React from 'react';

import CoinImg from '../assets/GoldAcesChip.svg';

import '../css/WalletOverview.scss';

export default function WalletOverview() {
    const amount = 600;
    return (
        <div className='flex-container column-flex overview-container'>
            <h2 className='title'>Your Wallet</h2>
            <div className='flex-container icon-container'>
                <h1 className='total'>{amount}</h1>
                <img src={CoinImg} className='coin-img' alt='gold coin with a skull on it' />
                <p className='spaces'>$paces</p>
            </div>
        </div>
    )
}